module.exports = __webpack_public_path__ + "img/image20.63f773c0.png";